<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" label="起止日期">
        <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll"
          :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期"
          v-decorator="['baodanData.startdata', { rules: [{ required: true, message: '请选择起始日期！' }] }]"
          @change="effectiveDateChange" @ok="selectDate" />
        <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled
          placeholder="结束日期" v-model="applicantInfoExpireDate" />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0">共{{ planOffsetDay }}天</span>
        <a-radio-group v-model="applicantInfo.mon" @change="onChangemon">
          <a-radio :disabled="disabledAll" v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="投保企业名称">
        <a-input v-model="applicantInfo.name" :disabled="disabledAll" @blur="e => handleChange(e.target.value, 'name')"
          v-decorator="['applicantInfo.name', { rules: [{ required: true, message: '请输入投保企业名称' }, {validator: (rule, value, callback) => checkName(rule, value, callback)}] }]"
          placeholder="请输入投保企业名称"></a-input>
      </a-form-item>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select :disabled="disabledAll" @change="value => handleChange(value, 'idType')" v-decorator="[
                'applicantInfo.idType',
                {
                  initialValue: applicantInfo.idType,
                  rules: [{ required: true, message: '请选择投保企业证件类型' }],
                },
              ]" placeholder="请选择投保企业证件类型">
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">
                {{ item.name }} </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
							<a-input v-model="applicantInfo.idNumber" @change="e => handleChange(e.target.value, 'idNumber')"
								:disabled="true" v-decorator="[
									'applicantInfo.idNumber',
									{
										rules: [{ required: true, message: '请输入投保企业证件号码' }],
									},
								]" placeholder="请输入投保企业证件号码"></a-input>
						</a-form-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
					</div>
        </a-col>
      </a-row>
      <a-form-item :label-col="{ span: 3 }" label="纳税人类型">
        <a-select placeholder="请选择" :disabled="disabledAll" @change="value => handleChange(value, 'enttypecode')"
          v-decorator="['applicantInfo.enttypecode', { rules: [{ required: true, message: '请选择' }] }]">
          <a-select-option v-for="item in ceryTypeList" :key="item.value" :value="item.value">{{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-row>
        <a-col :span="24">
          <a-form-item :label-col="{ span: 3 }" label="行业类别">
            <a-cascader :disabled="disabledAll" :options="industryList" :field-names="{ label: 'text' }"
              :show-search="{ filter }" @change="(value, label) => handleChange(value, 'industrycode', label)"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }" v-decorator="['applicantInfo.industrycode', { rules: [{ required: true, message: '请选择' }] }]"
              placeholder="请选择行业" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-col :span="8">
          <a-form-item :label-col="{ span: 9 }" label="联系地址">
            <a-cascader placeholder="请选择" :disabled="disabledAll"
              @change="(value, label) => handleChange(value, 'pacCode', label)" v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }],
                },
              ]" :options="addressOptions" :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }" style="float: left; width: 250px" />
          </a-form-item>
        </a-col>
        <a-col :span="14">
          <a-form-item>
            <a-input v-model="applicantInfo.address" :disabled="disabledAll"
              @change="e => handleChange(e.target.value, 'address')" v-decorator="[
                'applicantInfo.address',
                {
                  rules: [{ required: true, message: '请输入联系地址' }],
                },
              ]" placeholder="请输入联系地址" style="float: left; width: 350px; margin-left: 10px"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input v-model="applicantInfo.contactsname" @change="e => handleChange(e.target.value, 'contactsname')"
              :disabled="disabledAll" v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }, {validator: (rule, value, callback) => checkName(rule, value, callback)}],
                },
              ]" placeholder="请输入联系人姓名"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input v-model="applicantInfo.contactsphone" @change="e => handleChange(e.target.value, 'contactsphone')"
              :disabled="disabledAll" v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [
                    { required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' },
                  ],
                },
              ]" placeholder="请输入联系人电话"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input v-model="applicantInfo.email" @change="e => handleChange(e.target.value, 'email')"
              :disabled="disabledAll" v-decorator="[
                'applicantInfo.email',
                {
                  rules: [
                    { required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' },
                  ],
                },
              ]" placeholder="请输入联系人邮箱"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select @change="value => handleChange(value, 'payMethod')" style="width: 100%" placeholder="请选择支付类型"
              :disabled="disabledAll" v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付类型' }],
                },
              ]">
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <salInsuredList :disabledAll="disabledAll" :columns="columns" :data="data"
        :effectiveDate="applicantInfo.effectiveDate" @delSelect="delSelectpre" @addSelect="addSelectpre"
        @EduitSelect="eduitSelect"></salInsuredList>
      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input v-model="applicantInfo.totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px"> 投保人已充分阅读、理解并同意
          <fileView></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="policy_none">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" @click="handleSubmit('sisuan')"> 刷新试算 </a-button>
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll"
              @click="handleSubmit('save')"> 保存订单 </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll"
              @click="fastInsure"> 立即投保 </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne">
              编辑 </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 修改保费modal -->
    <a-modal v-model="modalVisible" title="修改保费" cancelText="取消" okText="确定" @ok="handleOk">
      <div v-for="(item, key) in addPcontent" :key="key">
        <div v-if="viewPcontent[key] > 0">
          请输入职业{{ key }}类保费(如不输入则按原值({{ viewPcontent[key] }})计算)：
          <a-input-number class="level_" :min="parseFloat(viewPcontent[key])" v-model="addPcontent[key]" />
        </div>
      </div>
    </a-modal>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定"
      cancelText="关闭">
      <p style="text-align: center; font-size: 18px; margin-bottom: 0; padding: 20px; line-height: 30px">
        您投保的{{ productName() }}需支付保费 <span
          style="color: #fe8f2d; font-weight: bold">{{ applicantInfo.totalPremium }}</span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
	import { mapState } from 'vuex';
  import moment from 'moment';
  import salInsuredList from './salInsuredList';
  import { policyMixin } from '@/mixins/policyMixin.js';
  import { idNumberMixins } from '@/mixins/idNumberMixins.js';
  import validatorMixin from '@/mixins/validator';
  let DATA = require('../data').default;
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: { salInsuredList },
    mixins: [policyMixin, idNumberMixins, validatorMixin],
    data() {
      //这里存放数据
      return {
        formData: {}, //传递数据
        yueduBtn: false, //理解阅读
        saveBtnShow: false, //保存过
        submitLoad1: false, //保存中
        showPaySure: false, //支付
        postPolicyData: {}, //要提交的数据
        policyId: '', //支付回来的id
        checkVisible: false, //凭证支付
        showQrcodePayModal: false, // 二维码支付
        /**需要的数据开始 */
        applicantInfo: {
          name: '', //投保企业名称
          idType: '6', //证件类型
          idNumber: '', //证件号码
          enttypecode: '', //纳税人类型
          pacCode: '', //省市区
          address: '', //详细地址
          industrycode: [], //行业类别
          contactsname: '', //联系人名称
          contactsphone: '', //联系人电话
          email: '', // 邮箱
          remark: '', //备注
          payMethod: '', //支付类型
          totalPremium: 0, //总保费
          expireDate: '', //保单终止时间
          effectiveDate: '', // 保单生效时间
          mon: 1, //保证期限
        },
        //表格的头部
        columns: DATA.columns,
        //表格的数据
        data: [],
        rate: 0.2, //费率
        industrycodeTEXT: '', //四级行业的文本
        maxType: 1, //最大类别
        companyCode: '01', //企业性质
        perRiskInfo: '', //险种类
        evidenceNumber: '', //凭证号
        riskNumber: {}, //计算保费
        uniqueArr: [], //去重后的人数列表
        //投保人证件类型
        companyIdTypeOptions: DATA.companyIdTypeOptions,
        //纳税人类型
        ceryTypeList: DATA.ceryTypeList,
        //发票类型
        invoiceprList: DATA.invoiceprList,
        //投保的天数
        guarantPre: DATA.guarantPre,
        loading: false,
        form: this.$form.createForm(this, { name: 'advanced_search' }),
        RiskInfos: {
          riskInfos: [
            {
              riskCode: 'disabilityByAccident', //意外身故及伤残
              amount: 100000,
            },
            {
              riskCode: 'accidentMedicalExpenses', //意外医疗费用
              amount: 0,
            },
            {
              riskCode: 'accidentMedicalExcess', //意外医疗费用免赔额（元）
              amount: 0,
            },
            {
              riskCode: 'accidentMedicalratio', //意外医疗费用赔付比例（百分比）
              amount: 0,
            },
            {
              riskCode: 'allowanceByAccident', //意外每日住院津贴
              amount: 0,
            },
            {
              riskCode: 'accidentDisabilityByPlane', //民航客运飞机意外身故及伤残
              amount: 0,
            },
            {
              riskCode: 'accidentDisabilityByTrain', //火车意外身故及伤残
              amount: 0,
            },
            {
              riskCode: 'accidentDisabilityByShip', //轮船意外身故及伤残
              amount: 0,
            },
            {
              riskCode: 'accidentDisabilityByCar', //公共汽车意外身故及伤残
              amount: 0,
            },
          ],
          salPolicy: {
            productCode: '', //产品code
            planCode: '',
            groupSize: 0, //人数
            creator: '', //用户id
            totalPremium: 0, //总保费
          },
          salPolicyExt: {
            isworkheightinvolved: 2,
          },
          salPolicyHolder: {
            addfifty: '2', // 测算类型
            name: '', //被保人名称
            stature: 2, //是否高空（2-否，1-是）
          },
          premiumBaseDtoList: [], //人数
        }, //测算的数据
        modalVisible: false, //修改保费的弹窗
        resultPcontent: {},
        viewPcontent: {}, //展示的保费
        addPcontent: {}, //拷贝的
        creator: '1',
        productCode: '',
        plan: '',
        /**需要的数据结束 */
        guapre: 1,
        baodanData: {
          startdata: '',
        },
        startValues: null,
        linshiContent: {},
        riskInfosAmount: {}, //计算险种的结果
        ZBAOFEI: 0, //原始保费
        addBAOFEI: 0, //修改添加的保费
        orderContent: {}, //订单的数据
        disabledAll: false, //是否是立即投保
        prohibitedIndustries: DATA.prohibitedIndustries,
        userParams: {
          userId: '',
          productCode: '',
        },
      };
    },
    //监听属性 类似于data概念
    computed: {
			...mapState({
				addresOption: (state) => state.addresCode.addresOption,//地址数据
			}),
      addressOptions() {
        let oneAddrCode = '210000 220000 230000 990000 650000 540000 630000 120000 910000 150000';
        let twoAddrCode = '513400 513200 513300 440700';
        let threeAddrCode = '130922 130321 130923 131082 131022 513328';
        let addresCode = this.addresOption;
        addresCode &&
          addresCode.forEach(e => {
            if (oneAddrCode.indexOf(e.value) > -1) {
              e['disabled'] = true;
            }
            if (e.children && e.children.length) {
              e.children.forEach(el => {
                if (twoAddrCode.indexOf(el.value) > -1) {
                  el['disabled'] = true;
                }
                if (el.children && el.children.length) {
                  el.children.forEach(es => {
                    if (threeAddrCode.indexOf(es.value) > -1) {
                      es['disabled'] = true;
                    }
                  })
                }
              });
            }
          });
        return addresCode;
      },
      //行业类别
      industryList() {
        return window.aszxtyOccDatas;
      },
      applicantInfoExpireDate() {
        let mon = this.applicantInfo.mon;
        let effectiveDate = this.applicantInfo.effectiveDate
        if(!effectiveDate) {
          return ''
        }
        // 当前月第一天
        if(this.moment(effectiveDate).format('YYYY-MM-DD')
          === this.moment(effectiveDate).startOf('month').format('YYYY-MM-DD')) {
            return this.moment(effectiveDate).add(mon - 1, 'months').endOf('month').format('YYYY-MM-DD 23:59:59')
        }
        let date = this.moment(effectiveDate).subtract(1, 'day').format('YYYY-MM-DD');
        return this.moment(date).add(mon, 'months').format('YYYY-MM-DD 23:59:59')
      },
      planOffsetDay() {
        if (this.applicantInfo.effectiveDate && this.applicantInfoExpireDate) {
          let end = this.moment(this.applicantInfoExpireDate);
          let offsetDay = end.diff(this.applicantInfo.effectiveDate, 'days') + 1;
          return offsetDay
        }
        return 0
      }
    },
    //监控data中的数据变化
    watch: {
      'applicantInfo.pacCode'(val) {
        sessionStorage.removeItem('pacCode');
        sessionStorage.setItem('pacCode', val[2].value || null);
      },
      'applicantInfo.industrycode'(val) {
        sessionStorage.removeItem('HYCode');
        sessionStorage.setItem('HYCode', val || null);
      },
      data: {
        //监听的对象
        handler: function (newV) {
          let newdata = this.numResult(newV);
          this.$bus.$emit('dataList', newdata);
        },
        deep: true, //深度监听设置为 true
      },
    },
    //方法集合
    methods: {
      moment,
      productName() {
        return sessionStorage.getItem('productName')
      },
      gonOne() {
        this.disabledAll = false;
        this.$bus.$emit('disabledBus', false);
        this.$router.push({
          name: 'aszxty',
          query: {
            u: this.$route.query.u,
            p: this.$route.query.p,
            sign: this.$route.query.sign,
            planCode: this.$route.query.planCode,
          },
        });
      },
      //打开文件列表
      fileListClick() {
        this.$store.commit('setNotShow', true);
      },
      //判断是否有多种类别
      checkBaseList(list) {
        return list.filter(e => e.personNum > 0).length > 0;
      },
      queryOrderDetails() {
        // 查询保单信息
        let parms = {
          policyId: this.$route.query.policyId,
        };
        this.$api.queryOrderDetails(parms).then(res => {
          if (res.data.returnCode == 0) {
            if (res.data.content) {
              this.orderContent = res.data.content;
              this.$store.commit('setOrderContent', this.orderContent);
              if (res.data.content.salInsuredList) {
                //被保人清单
                this.data = res.data.content.salInsuredList;
                this.data.forEach((element, i) => {
                  let str = element.birthDate;
                  element.occupation = [element.occupationCode.substring(0, 2), element.occupationCode.substring(0, 4), element.occupationCode]; //职业类别代码
                  element['index'] = i + 1;
                  element.birthDate = str.replace(/\//g, '-'); //生日
                });
              }
              if (res.data.content.riskInfos) {
                let riskInfos = res.data.content;
                this.$bus.$emit('busRiskInfos', riskInfos);
              }
              if (res.data.content.salPolicyHolderExt) {
                let salPolicyHolderExt = res.data.content.salPolicyHolderExt;
                this.industrycodeTEXT = salPolicyHolderExt.industryname;
              }
              if (res.data.content.salPolicy) {
                let salPolicy = res.data.content.salPolicy;
                this.policyId = salPolicy.id.toString();
                this.plan = salPolicy.planCode;
                this.applicantInfo.mon = parseInt(salPolicy.bracket);
                this.applicantInfo.totalPremium = salPolicy.totalPremium;
                this.applicantInfo.payMethod = salPolicy.payMethod;
                this.applicantInfo.remark = salPolicy.remark;
                this.creator = salPolicy.creator;
                this.productCode = salPolicy.productCode;
                this.$store.commit('setproductCode', this.productCode);
                this.applicantInfo.effectiveDate = moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss');
                this.applicantInfo.expireDate = moment(salPolicy.expireDate).format('YYYY-MM-DD HH:mm:ss');
                this.baodanData.startdata = this.applicantInfo.effectiveDate;
                this.form.setFieldsValue({
                  applicantInfo: {
                    ...salPolicy,
                    effectiveDate: moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss'),
                  },
                  baodanData: {
                    startdata: moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss'),
                  },
                });
              }
              if (res.data.content.salPolicyHolder) {

                let salPolicyHolder = res.data.content.salPolicyHolder;
                this.applicantInfo.name = salPolicyHolder.name;
                this.applicantInfo.pacCode = this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).arrCode;
                this.form.setFieldsValue({
                  applicantInfo: {
                    ...salPolicyHolder,
                    pacCode: this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).code,
                    industrycode: [salPolicyHolder.industrycode.slice(0, 1), salPolicyHolder.industrycode.slice(0, 3), salPolicyHolder.industrycode.slice(0, 4), salPolicyHolder.industrycode],
                  },
                });
                this.applicantInfo.contactsname = salPolicyHolder.contactsname;
                this.applicantInfo.contactsphone = salPolicyHolder.contactsphone;
                this.applicantInfo.address = salPolicyHolder.address;
                this.applicantInfo.email = salPolicyHolder.email;
                this.applicantInfo.enttypecode = salPolicyHolder.enttypecode;
                this.applicantInfo.idNumber = salPolicyHolder.idNumber;
                this.applicantInfo.idType = salPolicyHolder.idType;
                this.applicantInfo.industrycode = [salPolicyHolder.industrycode.slice(0, 1), salPolicyHolder.industrycode.slice(0, 3), salPolicyHolder.industrycode.slice(0, 4), salPolicyHolder.industrycode];
              }

              this.data = res.data.content.salInsuredList;
              this.riskNumber = this.countTimes(this.data);
              this.RiskInfos.premiumBaseDtoList = this.numResult(res.data.content.salInsuredList); //人员类别，处理成每一类的人数
              this.RiskInfos.salPolicy = {
                ...this.RiskInfos.salPolicy,
                ...res.data.content.salPolicy,
              };
              this.RiskInfos.salPolicyHolder = {
                ...this.RiskInfos.salPolicyHolder,
                ...res.data.content.salPolicyHolder,
              };
              this.RiskInfos.riskInfos = res.data.content.riskInfos; //险种信息
            }
          }
        });
      },
      filterPcode(arr) {
        let str;
        if (arr && arr.length) {
          if (isNaN(parseInt(arr[0]))) {
            str = 'text';
          } else {
            str = 'value';
          }
          if (!str) return;
          try {
            var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
            var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
            var twoArr = oneArr[0].children.filter(item => arr[1] == item[str]) || [];
            var threeArr = twoArr[0].children.filter(item => item[str] == arr[2]) || [];
            sessionStorage.setItem('pacCode', threeArr[0].value);
          } catch (error) {
            throw new Error(error);
          }
          return {
            code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
            arrCode: [oneArr[0], twoArr[0], threeArr[0]],
          };
        }
      },
      //确认修改
      handleOk() {
        let numResult = 0;
        let sumZfeiyong = this.sumZfeiyong(this.addPcontent, this.riskNumber);
        Object.values(sumZfeiyong).forEach(e => {
          numResult += e;
        });
        this.addBAOFEI = this.$accuracy.sub(Number(numResult), Number(this.ZBAOFEI));
        this.resultPcontent = this.addPcontent;
        this.modalVisible = false;
      },
      //修改保费
      changePremium() {
        if (JSON.stringify(this.resultPcontent) == '{}') {
          this.$message.error('您还没有计算保费');
          return;
        }
        this.modalVisible = true;
      },
      //反转对象
      resoverObj(obj) {
        var a = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
        };
        for (const key in obj) {
          a[key] = obj[key];
        }
        return a;
      },
      //统计次数
      numResult(data) {


        var d = [];
        var b = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
        };
        data.forEach(e => {
          let levelF = Number(e.occulevel.toString().slice(0, 1));
          if (b[levelF] !== undefined) {
            b[levelF] += 1;
          }
        });
        for (const key in b) {
          var c = {
            occupationKind: '',
            personNum: 0,
          };
          c.occupationKind = key;
          c.personNum = b[key];
          d.push(c);
        }

        return d;
      },
      //处理险种的拼接字段
      perRiskInfoNew(perRiskInfo) {
        var arrperRiskInfo = [];
        perRiskInfo.forEach(e => {
          if (e.riskCode == 'GSSGCJ' && e.amount > 0) {
            arrperRiskInfo.push('10-工伤身故、残疾-' + e.amount + '-' + e.premiumAmt);
          }
          if (e.riskCode == 'GSSGYL' && e.amount > 0) {
            arrperRiskInfo.push('11-工伤事故医疗费用-' + e.amount + '-' + e.premiumAmt);
          }
          if (e.riskCode == 'TZSBFWW' && e.amount > 0) {
            arrperRiskInfo.push('55-扩展社保范围外医疗费用-' + e.amount + '-' + e.premiumAmt);
          }
          if (e.riskCode == '24HYWXTB' && e.amount > 0) {
            arrperRiskInfo.push('44-24小时意外险特别扩展条款-' + e.amount + '-' + e.premiumAmt);
          }
          if (e.riskCode == 'YWZYJTMC' && e.amount > 0) {
            arrperRiskInfo.push('22-意外住院津贴每次事故-' + e.amount + '-' + e.premiumAmt);
          }
          if (e.riskCode == 'WGF' && e.amount > 0) {
            arrperRiskInfo.push('33-误工费-' + e.amount + '-' + e.premiumAmt);
          }
          if (e.riskCode == 'YCXSCJY' && e.amount > 0) {
            arrperRiskInfo.push('66-一次性伤残就业补助金-' + e.amount + '-' + e.premiumAmt);
          }
          if (e.riskCode == 'SHHLF' && e.amount > 0) {
            arrperRiskInfo.push('77-生活护理费-' + e.amount + '-' + e.premiumAmt);
          }
          if (e.riskCode == 'GSDCGPF' && e.amount > 0) {
            arrperRiskInfo.push('100-工伤定残高赔付标准-' + e.amount + '-' + e.premiumAmt);
          }
        });

        return arrperRiskInfo.join('#');
      },
      filter(inputValue, path) {
        return path.some(option => {
          return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
        });
      },
      //测算的总价格
      cesuannum(data) {
        var a = {};
        var resultnum = 0;
        this.RiskInfos.premiumBaseDtoList.forEach(e => {
          a[e.occupationKind] = e.personNum;
        });
        for (const key in a) {

          resultnum += a[key] * data[key];
        }

        return resultnum.toFixed(2);
      },
      //统一处理是否调用试算的接口
      IsCallPremiumSumMethod() {

        let newAppInfo = this.$lodash.cloneDeep(this.applicantInfo);
        newAppInfo.expireDate = moment(this.applicantInfoExpireDate).format('YYYY-MM-DD')
        if (newAppInfo.invoiceprinttype == '01') {
          delete newAppInfo['taxpayercertificateno'];
        }
        delete newAppInfo['totalPremium'];
        delete newAppInfo['remark'];
        newAppInfo['dataSize'] = this.data.length;
        let Isrequest = Object.values(newAppInfo).every(e => Boolean(e) == true);
        if (Isrequest) {
          this.handleSubmit('sisuan');
        }
      },
      //试算的接口
      async resultPremiumSum(formData) {
        await this.$api.calPremiumEmployer(formData).then(res => {
          if (res.data.success) {
            let datas = res.data.content;

            this.applicantInfo.totalPremium = datas; //总保费
          } else {
            this.$message.error(res.data.returnMsg + '错误');
          }
        });
      },
      //选择天数的
      onChangemon(e) {


        this.form.setFieldsValue({
          applicantInfo: {
            mon: e.target.value,
          },
        });
        this.applicantInfo.mon = e.target.value;
        this.RiskInfos.salPolicy.bracket = this.applicantInfo.mon;
        this.IsCallPremiumSumMethod();
      },
      //处理时间的
      effectiveDateChange(date1, date) {
        this.applicantInfo.effectiveDate = date;
      },
      //处理时间确定
      selectDate() {
        this.IsCallPremiumSumMethod();
      },
      //开始时间
      disabledDate(current) {
        var dd = new Date();
        dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
        var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
        var time = y + '-' + m + '-' + d;
        var currents = moment(time);
        return current && current < currents;
      },
      //修改
      eduitSelect(data) {
        this.data.forEach((e, i) => {
          if (i == data.eduitIndex) {
            this.data[i] = data;
          }
          if (e.occulevel.toString().indexOf('类') <= -1) {
            e.occulevel = e.occulevel + '类';
          }
        });
        this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
        this.riskNumber = this.countTimes(this.data);
        this.IsCallPremiumSumMethod();
      },
      //粘贴
      addSelectpre(data) {
        if (Array.isArray(data)) {
          var datas = data;
          this.data.push(...datas);
        } else {
          this.data.push(data);
        }
        let cesiData = this.$lodash.cloneDeep(this.data);
        this.data = this.unique(this.data, 'idNumber');
        if (cesiData.length != this.data.length) {
          this.$message.warning('受保人有重复，已做删除');
        }
        this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
        this.riskNumber = this.countTimes(this.data);
        // this.IsCallPremiumSumMethod();
      },
      //批量删除
      delSelectpre(data) {
        this.data = data;
        let cesiData = JSON.parse(JSON.stringify(this.data));
        this.data = this.unique(this.data, 'idNumber');
        if (cesiData.length != this.data.length) {
          this.$message.warning('受保人有重复，已做删除');
        }
        this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
        this.riskNumber = this.countTimes(this.data);
        if (this.data.length) {
          // this.IsCallPremiumSumMethod();
        } else {
          this.applicantInfo.totalPremium = 0;
        }
      },
      //提交的去重
      unique(arr, attribute) {
        var new_arr = [];
        var json_arr = [];
        for (var i = 0; i < arr.length; i++) {
          if (new_arr.indexOf(arr[i][attribute]) == -1) {
            //  -1代表没有找到
            new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
            json_arr.push(arr[i]);
          }
        }
        return json_arr;
      },
      salInsuredList(data) {

        let newData = this.$lodash.cloneDeep(data);
        newData.filter(e => {
          switch (e['gender']) {
            case '男':
            case 'M':
              e['gender'] = 'M';
              break;
            case '女':
            case 'F':
              e['gender'] = 'F';
              break;
          }
          e['beneficialType'] = 1;
          e['occulevel'] = Number(e.occulevel.toString().slice(0, 1));
        });
        return newData;
      },
      //计算总保费
      countTimes(data) {
        var a = [];
        if (data.length) {
          data.forEach(e => {
            let leve = e.occulevel.toString().indexOf('类') > -1 ? Number(e.occulevel.toString().slice(0, 1)) : Number(e.occulevel);
            a.push(leve);
          });
          return a.reduce(function (time, name) {
            if (name in time) {
              time[name]++;
            } else {
              time[name] = 1;
            }
            return time;
          }, {});
        } else {
          return {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0,
            6: 0,
          };
        }
      },
      //计算总保费
      sumZfeiyong(content, riskNumber) {
        var jichu = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
        };
        for (const key in content) {
          jichu[key] = this.$accuracy.mul(Number(content[key]), Number(riskNumber[key] || 0));
        }

        return jichu;
      },
      //最后的提交
      handleSubmit(type) {
        let ageStatus = true;
        this.data.forEach(e => {
          let age = this.$tools.jsGetAge(e.birthDate, moment(this.applicantInfo.effectiveDate).format('YYYY-MM-DD'));
          if (age < 16 || age > 65) {
            this.$message.error('投保人年龄仅限于16-65周岁，请修改后再试！');
            ageStatus = false;
            return;
          }
        });
        if (!ageStatus) {
          return;
        }
        this.form.validateFields(async (err, values) => {
          if (!err) {
            let base = this.applicantInfo;
            if (this.data.length < 5) {
              this.$message.warning('最低投保人数5人');
              return;
            }
            // 含4-6类职业，最低投保人数10人判断
            let fourNum = this.RiskInfos.premiumBaseDtoList[3].personNum;
            let fiveNum = this.RiskInfos.premiumBaseDtoList[4].personNum;
            let sixNum = this.RiskInfos.premiumBaseDtoList[5].personNum;
            let num456 = Number(fourNum) + Number(fiveNum) + Number(sixNum);
            if (num456 > 0 && this.salInsuredList(this.data).length < 10) {
              this.$message.warning('4-6类职业最低投保人数10人');
              return;
            }
            let data = {
              premiumBaseDtoList: this.numResult(this.data), //人员类别，处理成每一类的人数
              salInsuredList: this.salInsuredList(this.data), //表格的数据
              salPolicy: {
                //保单信息
                planCode: this.plan || this.productCode, //产品计划 （固定值ConstructAccident）
                productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
                creator: this.creator,
                id: this.policyId,
                effectiveDate: moment(values.baodanData.startdata).format('YYYY-MM-DD'), //startTime  保单生效时间
                expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime   保单终止时间
                payMethod: values.applicantInfo.payMethod, //支付类型”
                bracket: this.applicantInfo.mon, //页面选择的保障期间（几个月就传几，整数）
                groupSize: this.data.legnth || 0, //投保人数
                totalPremium: base.totalPremium, //totalPremium  总保费
                remark: values.applicantInfo.remark, //备注
                ordertraceno: '', //"凭证支付时的凭证号",
              },
              salPolicyHolderExt: {
                industryname: this.industrycodeTEXT,
              },
              salPolicyExt: {
                occEmpVersion: this.fileCodeContent.id,
                isworkheightinvolved: this.RiskInfos.salPolicyHolder.stature, //是否高空作业
              },
              salPolicyHolder: {
                type: 'C', //固定值
                addfifty: '2', // 测算类型
                //投保人信息
                enttypecode: values.applicantInfo.enttypecode, //纳税人类型
                name: values.applicantInfo.name, //name  投保人名称
                idType: values.applicantInfo.idType, //证件类型
                idNumber: values.applicantInfo.idNumber, //certNo   证件号码
                gender: 'M', //  联系人性别
                address: values.applicantInfo.address, //详细地址
                addresscode: `${base.pacCode[0].value}-${base.pacCode[1].value}-${base.pacCode[2].value}`,
                contactsname: values.applicantInfo.contactsname, //联系人姓名
                contactsphone: values.applicantInfo.contactsphone, //联系人电话
                email: values.applicantInfo.email, //联系人邮箱
                industrycode: values.applicantInfo.industrycode[3], //行业类型
                province: base.pacCode[0].text, //省
                city: base.pacCode[1].text, //市
                district: base.pacCode[2].text, //区
                stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
              },
              riskInfos: this.RiskInfos.riskInfos.filter(item => item.amount > 0),
            };
            this.postPolicyData = data;
            if (this.$route.query.policyId) {
              this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
            }
            if (type == 'sisuan') {
              if (!this.disabledAll) {
                this.resultPremiumSum(this.postPolicyData);
              }
              return;
            }
            this.$store.commit('setproductCode', this.productCode);
            if (type == 'save') {
              // 保存前调用一次试算
              if (!this.disabledAll) {
                await this.resultPremiumSum(this.postPolicyData);
              }
              this.submitLoad1 = true;
              this.axiosPolicy(); // 保存订单是 直接保存
            }
          } else {
            this.$message.error('请填写完整提交的数据');
          }
        });
      },
      //立即投保
      fastInsure() {
        if (!this.yueduBtn) {
          this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
          return;
        }
        this.policyId = this.$route.query.policyId;
        this.$store.commit('setLoading', { show: true, text: '正在核保...' });
        this.$api
          .getPolicyQuotation({
            //这里会返回真正的保费，这是核保接口
            policyId: this.policyId,
          })
          .then(res => {
            if (res.data.returnCode == '0000') {
              this.applicantInfo.totalPremium = res.data.content;
              this.showPaySure = true;
            }
          })
          .finally(() => {
            this.$store.commit('setLoading', { show: false });
          });
      },
      axiosPolicy() {
        //提交保单
        this.$api
          .employerPolicy(this.postPolicyData)
          .then(res => {
            if (res.data.returnCode == '00') {
              this.showPaySure = false;
              this.saveBtnShow = true;
              this.policyId = res.data.content;
              this.$message.success('保存成功！');
              this.$router.push({
                name: 'aszxty',
                query: {
                  u: this.$route.query.u,
                  p: this.$route.query.p,
                  sign: this.$route.query.sign,
                  policyId: this.policyId,
                  planCode: this.$route.query.planCode,
                  continuation: '1'
                },
              });
              this.disabledAll = true;
              this.$bus.$emit('disabledBus', true);
            }
          })
          .finally(() => {
            this.submitLoad1 = false;
            // this.submitLoad2 = false;
          });
      },
      paySure() {
        //支付确认
        this.showPaySure = false;
        this.submitLoad1 = false;
        this.submitLoad2 = false;
        this.policyId = this.$route.query.policyId;
        this.$payModal({
          show: true,
          type: 'aszxty', //产品类型
          policyId: this.policyId, //产品id
          creator: this.creator, //用户id
          payMethod: this.applicantInfo.payMethod, //支付方式
          productCode: this.$route.query.p, //产品code
          name: this.applicantInfo.name,
          totalPremium: this.applicantInfo.totalPremium, //支付总金额
        });
      },
      handleChange(value, type, label) {
        if (type == 'name') {
          let valid = this.prohibitedIndustries.every((element) => {
            if (value.indexOf(element) != -1) {
              this.$message.error(`投保人名称包含拒保关键字，无法投保该产品！`);
              this.form.setFieldsValue({
                applicantInfo: {
                  name: ""
                },
              });
              this.applicantInfo.name = ''
              return false;
            } else {
              return true;
            }
          });
          if (!valid) {
            return
          }
          // 查询证件号
          this.queryCompanyIdNumber(value, 1)
        }
        if (type == 'pacCode') {
          this.applicantInfo[type] = label;
          sessionStorage.setItem('pacCode', value[2]);
        } else if (type == 'industrycode') {
          sessionStorage.setItem('HYCode', value);
          this.industrycodeTEXT = label ? label[3].text : '';
          this.applicantInfo[type] = value;
        } else {
          this.applicantInfo[type] = value;
        }
        this.IsCallPremiumSumMethod();
      },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.$bus.$on('onRiskInfos', data => {
        let strdata = this.$lodash.cloneDeep(data);
        this.RiskInfos.riskInfos = strdata.riskInfos;
        this.RiskInfos.salPolicy = strdata.salPolicy;
        this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
        this.IsCallPremiumSumMethod();
      });
    },
  };
</script>
<style lang="scss" scoped>
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .btn_color {
    margin: 0 20px;
  }
</style>